import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { EmptyTableText, Table } from '@commonClient2/components';
import { BidProcessType } from '../../../../../Enums';
import { displayNotificationCustomTags } from '../../../../store/appData';

const sequentialOnlyTags = ['bidPriorityDate', 'bidPriorityTime', 'bidPriorityDuration', 'bidPriorityRank'];
const addDetailsToString = (/** @type {any} */ string) => `${string}Details`;

const NotificationTags = () => {
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'admin.setupEdit.notificationStep.tags' });
    const dispatch = useDispatch();
    /** @type {ShiftBidding.AdminStore} */
    // @ts-ignore
    const { adminAppData, adminSetup, pendingTasks } = useSelector((state) => state);
    const { bidProcessType } = adminSetup;
    const { notificationCustomTags } = adminAppData;
    const columns = [
        {
            key: 'customTag',
            tKey: 'columns.customTag',
            sortable: true,
            flexGrow: 1,
            minWidth: 253,
        },
        {
            key: 'customTagDetails',
            tKey: 'columns.customTagDetails',
            sortable: true,
            flexGrow: 2,
            minWidth: 506,
        },
    ];

    let mappedTags = notificationCustomTags?.map((tag) => ({
        value: tag,
        customTag: t(tag),
        customTagDetails: t(addDetailsToString(tag)),
    }));

    const isPreferential = bidProcessType === BidProcessType.Preferential;
    if (isPreferential) {
        mappedTags = mappedTags?.filter((tag) => !sequentialOnlyTags.includes(tag.value));
    }

    useEffect(() => {
        dispatch(displayNotificationCustomTags());
    }, []);

    return (
        <Table
            data={mappedTags || []}
            id="tags-table"
            renderEmpty={() => <EmptyTableText text={t('noThreshold')} />}
            rowClassName="table-row"
            disableSearch
            columns={columns}
            height={isPreferential ? 410 : 550}
            loading={!!pendingTasks}
        />
    );
};
export default NotificationTags;
